import { styled, Box } from '@mui/material';

export const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),

  // Global input border radius override for this component
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px !important',

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '12px !important',
    },
  },

  // Custom select border radius
  '& .MuiSelect-select': {
    borderRadius: '12px !important',
  },

  '& .MuiFormControl-root .MuiOutlinedInput-root': {
    borderRadius: '12px !important',
  },
}));

export const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: 15,

  '& .mainTitle': {
    fontWeight: 700,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: 15,
  },

  '& .weightedScoreBox': {
    backgroundColor: 'rgba(243, 245, 247, 1)',
    borderRadius: 8,
    padding: '10px 12px',

    '& .title': {
      fontWeight: 700,
      fontSize: 14,
      color: 'rgba(33, 33, 33, 1)',
      marginBottom: 2,
    },
    '& .description': {
      fontWeight: 500,
      fontSize: 13,
      color: 'rgba(66, 66, 66, 1)',
    },
  },
}));

export const ThresholdRow = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  border: '1px solid transparent',

  '&:hover': {
    border: '1px solid #E0E0E0',
  },
}));

// New styled component for overlapping threshold wrapper
export const ThresholdRowWrapper = styled(Box)<{ isOverlapping?: boolean }>(
  ({ theme, isOverlapping }) => ({
    ...(isOverlapping && {
      borderRadius: '8px',
      backgroundColor: '#fef2f2',
    }),
  }),
);

export const AddThresholdButtonCnt = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderRadius: 6,
  padding: '4px 12px',
  marginTop: 10,
  backgroundColor: 'rgba(245, 245, 255, 1)',
  border: '1px solid rgba(204, 203, 255, 1)',
  '& .addBtn': {
    fontWeight: 700,
    fontSize: 13,
    color: '#4E48FA',
  },
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  padding: 8,
  backgroundColor: 'rgba(245, 245, 245, 1)',
  marginBottom: 5,
}));

export const ThresholdGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '60px 150px 150px 80px 20px 80px 40px',
  gap: '12px',
  alignItems: 'center',

  '& .headerTitle': {
    fontWeight: 700,
    fontSize: 13,
    color: '#000000',
  },
}));

export const ColorButton = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '40px',
  borderRadius: '12px',
  border: '1px solid #D1D5DB',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 12px',
  position: 'relative',

  '&:hover': {
    borderColor: '#9CA3AF',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },

  '&:focus': {
    outline: 'none',
    borderColor: '#6366F1',
    boxShadow: '0 0 0 3px rgba(99, 102, 241, 0.1)',
  },
}));

export const ColorPreview = styled(Box)(({ color }) => ({
  width: '20px',
  height: '20px',
  borderRadius: '6px',
  backgroundColor: color,
  border: '2px solid #fff',
  boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
  flexShrink: 0,
}));

export const EmptyStateContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 20px',
  background:
    'linear-gradient(90deg, rgba(0, 210, 255, 0.1) 0%, rgba(58, 123, 213, 0.1) 100%)',
  borderRadius: 16,
  height: 164,

  '& .icon': {
    width: 62,
    height: 63,
    marginBottom: 10,
  },

  '& .title': {
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 3,
    color: 'rgba(0, 0, 0, 1)',
  },
  '& .description': {
    fontWeight: 500,
    fontSize: 14,
    color: 'rgba(38, 50, 56, 1)',
  },
}));

// New styled component for overlap error message
export const OverlapErrorContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fef2f2',
  border: '1px solid #ef4444',
  borderRadius: '8px',
  padding: '12px 16px',
  marginTop: '16px',
  marginBottom: '16px',
}));

// New styled component for delete button container
export const DeleteButtonContainer = styled(Box)(({ theme }) => ({
  marginLeft: '-10px',
}));
